import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function HomeVeille() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div data-testid="page-home-veille" className="bg-[#FAF9F7] text-[#181A1D] min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 relative grain">
        <div className="hero-blur-lines absolute inset-0 opacity-50" />
        <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-10 pt-40 lg:pt-52 pb-28 lg:pb-36">
          <p className="label-eyebrow mb-6">HorsIndex</p>
          <h1
            data-testid="veille-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#181A1D] tracking-tight leading-[1.05] font-normal text-balance"
          >
            Réduire la surface publique d'exposition numérique.
          </h1>
          <div className="h1-marker mt-8 mb-10" />
          <div className="space-y-5 text-base lg:text-lg text-[#52565C] font-normal leading-relaxed max-w-2xl">
            <p data-testid="veille-text-1">
              HorsIndex est un projet consacré à la maîtrise de l'exposition
              numérique des personnes et des organisations : cartographier ce
              qui est visible en ligne, comprendre comment l'information
              circule et engager les démarches utiles.
            </p>
            <p data-testid="veille-text-2">
              HorsIndex poursuit son chemin comme espace de réflexion et de
              ressources autour de l'exposition numérique. Les prochains mois
              seront consacrés à approfondir le projet, enrichir ses contenus
              et faire évoluer son approche, avant une reprise ultérieure de
              son activité commerciale.
            </p>
          </div>
          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-4">
            <Link
              to="/simon-marie"
              data-testid="veille-link-simon-marie"
              className="inline-flex items-center gap-2 text-[15px] font-medium text-[#181A1D] underline decoration-[#D8D3CD] underline-offset-4 hover:decoration-[#E94B3C] transition-colors"
            >
              À propos de Simon Marie
              <ArrowRight size={14} strokeWidth={1.5} />
            </Link>
            <Link
              to="/contact"
              data-testid="veille-link-contact"
              className="inline-flex items-center gap-2 text-[15px] font-medium text-[#52565C] hover:text-[#181A1D] underline decoration-[#D8D3CD] underline-offset-4 hover:decoration-[#181A1D] transition-colors"
            >
              Prendre contact
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
